$(document).ready(function() {
    $(".calculate-slider").slick({
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 1,
         centerMode: true,
    })
})


let accomodation = document.querySelectorAll(".calculate-item-accomodation");
let service = document.querySelectorAll(".calculate-item-service");

function changeCalculateItem(items) {
    for(let i = 0; i < items.length; i++) {
        items[i].addEventListener("click", function() {
            for(let i = 0; i < items.length; i++) {
                items[i].classList.remove("active");
            }
            this.classList.add("active");
        })
    }
}

changeCalculateItem(accomodation);
changeCalculateItem(service);